<div class="painel-board-container">
  @for (fase of fasesView; track fase.nome; let i = $index) {
    @if (i > 0) {
      <tds-divider orientation="vertical" variant="dark-blue"></tds-divider>
    }

    <div class="painel-column">
      <h2>{{ fase.nome }}</h2>

      @for (item of fase.itens; track item.filaId) {
        <app-painel-card [item]="item"></app-painel-card>
      }
    </div>
  }
</div>
